import { render, staticRenderFns } from "./UnpaidLeaveInfo.vue?vue&type=template&id=3a810ff2&scoped=true&"
import script from "./UnpaidLeaveInfo.vue?vue&type=script&lang=js&"
export * from "./UnpaidLeaveInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a810ff2",
  null
  
)

export default component.exports